import React, { useState } from "react";
import { TextField, Box, Typography, Button, Divider } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { useGetLocationsQuery } from "slices/common/locationSlice";

function Step2({ initialData, onNext, onBack }) {
  const { data } = useGetLocationsQuery({});

  const validationSchema = Yup.object().shape({
    allowedCities : Yup.array()
      .of(Yup.string().required("This is required"))
      .min(1, "At least one city must be selected")
      .required("Cities are required"),
  });

  const initialValues = {
    allowedCities : initialData?.allowedCities  || [],
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
        validationSchema={validationSchema}
      onSubmit={async (values, { setSubmitting }) => {
        console.log("values to backend", values);
        onNext(values);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        setFieldValue,
        isSubmitting,
      }) => (
        <Form>
          <Box className="container py-4">
            <Typography variant="h5" gutterBottom>
              Select Cities
            </Typography>

            {/* City Select */}
            <Select
              name="cities"
              options={data?.data?.data?.map((city) => ({
                label: city.cityName,
                value: city._id,
              }))}
              isMulti
              onChange={(selectedOptions) => {
                const selectedCityIds = selectedOptions.map((opt) => opt.value);
                setFieldValue("allowedCities", selectedCityIds);
              }}
              value={data?.data?.data
                ?.filter((city) => values.allowedCities.includes(city._id))
                .map((city) => ({
                  label: city.cityName,
                  value: city._id,
                }))}
              placeholder="Select Cities"
              className="basic-multi-select"
              classNamePrefix="select"
            />

            {/* Show validation error */}
            {touched.allowedCities  && errors.allowedCities  && (
              <Typography variant="caption" color="error">
                {errors.allowedCities}
              </Typography>
            )}

            <Divider sx={{ my: 3 }} />

            {/* Submit Button */}
            <Box display="flex" justifyContent="flex-end" gap={2} mt={3}>
              <Button
                type="button"
                variant="contained"
                color="primary"
                onClick={onBack}
              >
                Back
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={isSubmitting}
              >
                Next
              </Button>
            </Box>
          </Box>
        </Form>
      )}
    </Formik>
  );
}

export default Step2;
